export default{
    data() {
        return {
            stockItems : JSON.parse(localStorage.getItem("stockItem"))
        }
    },
    methods : {
        $isUrlParse : function(url) {
            let regex = /(http|https):\/\/?/;
            if (regex.test(url)) {
                return true;
            }
            return false;
        }, 
        $removeSpecialChar : function(_text) {
            //eslint-disable-next-line
            var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]/gi;
            var _title1 = _text.replaceAll(regExp, ' ');
            return _title1;
        },
        $isPasswordCheck : function(_password) {
            //숫자, 특문 각 1회 이상, 영문은 2개 이상 사용하여 8자리 이상 입력
            //eslint-disable-next-line
            var regExpPw = /(?=.*\d{1,50})(?=.*[~`!@#$%\^&*()-+=]{1,50})(?=.*[a-zA-Z]{2,50}).{8,50}$/;
            return regExpPw.test(_password);
        }, 
        $isMailCheck : function(_email) {
            //eslint-disable-next-line
            var regExpEm = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
            return regExpEm.test(_email);
        },
        $isPhone : function(_tel) {
            let regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
            return regPhone.test(_tel);
        },
        $makeSha256 : function(_str) {
            return crypto.createHash('sha256').update(_str).digest('hex')
        },
        $findStockCode : function(_stockName, isEqual) {
            if (this.$fnObjectNull(_stockName))
                return "";

            var stockItems = JSON.parse(localStorage.getItem("stockItem"));
            var findData =  stockItems.find((data) => {
                if (isEqual) {
                    if (data.stockName === _stockName) {
                        return true;
                    }
                } else {
                    if (data.stockName.indexOf(_stockName) >= 0) {
                        return true;
                    }
                }
            });

            if (findData) {
                return findData.stockCode;
            }
            return "";
        },
        $findStockNameofSplit(_title) {
            var chageText = this.$removeSpecialChar(_title);
            var splitText = chageText.split(" ");
            for (var text of splitText) {
                if (!this.$fnObjectNull(text)) {
                    let findStock = this._fnSearchStockName(text, true);
                    if (findStock && findStock.length> 0) {
                        this.$log("findStock : " + JSON.stringify(findStock));  
                        return findStock[0].stockCode;
                    }
                }
            }
            return "";
        },

        _fnSearchStockName(_search) {
            return this.stockItems.filter((data) => {
                if (data.stockName == _search)
                    return true;
            });
        },

        $findStockofTitle(_title) {
            var chageText = this.$removeSpecialChar(_title);
            var splitText = chageText.split(" ");

            for (var text of splitText) {
                var stockCode = this.$findStockCode(text,true);
                if (stockCode) {
                    let _data = {};
                    _data.stockName = text;
                    _data.stockCode = stockCode;
                    return _data;
                }
            }
        },

        $findCategoryUID : function(_categoryName) {
            var categoryItems = JSON.parse(localStorage.getItem("category"));

            var findData =  categoryItems.find((data) => {
                if (data.name == _categoryName) {
                    return true;
                }
            });

            if (findData) {
                return findData.uid;
            }
            return "";
        },
        $findCategoryObjectOfName : function(_name) {
            var categoryItems = JSON.parse(localStorage.getItem("category"));
            if (categoryItems != null) {
                var findData =  categoryItems.find((data) => {
                    if (data.name.indexOf(_name) >=0 )
                        return true;
                });
    
                if (findData) {
                    return findData;
                }
            }
            return "";
        },
        /*
        findCategoryObjectOfUID : function(_uid) {
            var categoryItems = JSON.parse(localStorage.getItem("category"));
            if (categoryItems != null) {
                var findData =  categoryItems.find((data) => {
                    var len = _uid.indexOf(data.uid);
                    if (len >=0) {
                        return true;
                    }
                });
    
                if (findData) {
                    return findData;
                }
            }
            return "";
        },
        */
        $findThemeObject : function(_UID) {
            var themeLists = JSON.parse(localStorage.getItem("themeList"));
            if (themeLists != null) {
                var findData =  themeLists.find((theme) => {
                    if (theme.UID == _UID)
                        return true;
                });
    
                if (findData) {
                    return findData;
                }
            }
            return "";
        },        
        $fnObjectNull(object) {
            if( object == null || object == '' || object == 'undefined')
                return true;

            return false;
        },
        $getBasicTemplate() {
            basic +="}</style></head><body>";
            var basic =  "<html><head> <style type='text/css'><!-- .reportImg { display: block;  } .en-code { font-family: monospace;box-sizing: border-box;padding: 8px; font-family: Monaco,Menlo,Consolas,Courier New,monospace;font-size: 12px;color: #333;border-top-left-radius: 4px;border-top-right-radius: 4px;border-bottom-right-radius: 4px;border-bottom-left-radius: 4px;background-color: #fbfaf8;}";
            basic +="</style></head><body>";
            basic +="<div id='title_date'>2021.11.15</div><div>Signal Report</div><p>&nbsp;</p><div>'Signal Report'는 인공지능으로 수집되는 데이터를 기반으로 한&nbsp;시황 알고리즘 서비스이며 저작권의 보호를 받습니다.</div>";
            basic +="<div>구독자 본인 외에 다른 사람에게&nbsp; 공유는 엄격히 금지됩니다.</div><div>지정된 수신자 외에 다른 사람에게 전달되는 것이 적발될 경우 민형사상의 책임을 질 수 있습니다.</div><div>본 리포트의 내용은 주식의 매도, 매수 등을 추천하는 것이 아닙니다. 모든 매매는 본인의 판단으로 하십시오.</div><p>&nbsp;</p><hr /><p>&nbsp;</p>";
            basic +="<h2><span style='background-color: #ffff99;' id='daily_comment'>11월 15일 (월) Daily point</span></h2>";
            basic +="<div>&nbsp;</div><div class='en-code'><div>'Daily Point'는 당일 증시의 시황을 설명 드리는 코너입니다.</div><div>시황을 알아야 업황을 예측할 수 있고 종목을 고를 수 있습니다. 나아가 스윙과 장투에 있어서도 필수적입니다.</div>        <div>하루 하루 쌓아가는 'Daily Point'를 통해 주식 실력 근원이 더욱 단단해질 수 있습니다.</div>        </div>  <div>&nbsp;</div> <div id='report_daily'>&nbsp;</div>  <div>&nbsp;</div>        <div>&nbsp;</div>        <hr />        <div>&nbsp;</div> <h2><span style='background-color: #ffff99;' data-en-has-metadata='true'>[ TODAY PICK ]</span></h2>        <div>&nbsp;</div>        <div>        <div class='en-code'>        <div>'Today Pick'은 당일 Signal report의 전체를 최대한 축약한 버전입니다.</div>        <div>전체 시그널 리포트를 보면서 공부하는 게 제일 좋지만, 시간이 없거나 갑작스런 일정이 생긴 분들은 'Today Pick' 코너만이라도 보아야 합니다.</div>        <div>주식은 쌓아가는 것입니다. 하루도 놓치지 않고 1년을 공부해보면, 2년차부터는 '주식은 반복이다'라는 말을 깨닫게 됩니다.</div>        <div>반복의 역사를 알다보면 '다음에 생길 이벤트'를 알 게 되고, 미리 오를 자리를 선점할 수 있습니다.</div>        </div>        <p>&nbsp;&nbsp;</p>        </div>        <hr />        <div>&nbsp;</div>        <h2><span style='background-color: #ffff99;' data-en-has-metadata='true'>[ 전일 시장 주도 종목 ]&nbsp;</span></h2>        <p>&nbsp;&nbsp;</p>        <div class='en-code'>            <div>'전일 시장 주도 종목'은 거래일 기준 전(前)일 일어난 주요 종목과 그에 따른 이벤트를 다룬 콘텐츠입니다.</div>            <div>시장에서 주가를 움직이는 이벤트는 무엇이었는가를 알 수 있으며, 해당 이벤트가 다음 날까지 이어지는 강도인지를 파악하는데 도움을 줍니다.</div>            <p>&nbsp;</p>            <div>무엇보다 해당 종목이 '왜 올랐는지'를 아는 것은 주식의 시작입니다.</div>            <div>해당 종목을 오르게 한 이슈는 일회성이지 않습니다. 종목이 상폐되기 전날까지도 종목을 오르게 하는 강력한 원동력이 되기 때문에 꼭 알아둬야 합니다.</div>            <div>차트가 좋을 때, 해당 종목의 이슈가 살아 있는 경우 80% 이상의 확률로 다시 시세를 주게 됩니다.</div>            <p>&nbsp;</p>        </div>        <p>&nbsp;</p>    <div id='report_stocks'> 주요 종목 이미지 </div>    <div id='report_pb'>             전일 시장 주도 종목 내용         </div>        <p>&nbsp;</p>        <hr />        <p>&nbsp;</p>        <h2><span style='background-color: #ffff99;' data-en-has-metadata='true'> [ to the DEEP ]</span></h2>        <div class='en-code'>        <div>* 위에서 언급한 해설 외에 조금 더 알면 좋을 내용을 넣는 코너입니다</div> </div>    <br>    <div id='report_deep'>                 to the deep            </div>        <p>&nbsp;</p>        <hr />        <p>&nbsp;</p>        <h2><span style='background-color: #ffff99;' data-en-has-metadata='true'> [ 장 전/후 시간 외 주요 사항 ]</span></h2>        <div class='en-code'>            <div>장 전에 움직인 종목을 보면서 당일 주식 시장을 예측하는데 도움을 받을 수 있습니다.</div>        </div>        <br/>            <div id='report_blockdeal'>                 장 전/후 시간 외 주요 사항 본문            </div>        <br/>        <hr />        <br/>        <h2><span style='background-color: #ffff99;' data-en-has-metadata='true'> [ 일정 ]</span></h2>        <br/>            <div id='report_event'>                 일정 본문 본문            </div>        <br>        <hr />        <p>&nbsp;</p>        <h2><span style='background-color: #ffff99;' data-en-has-metadata='true'> [ 차트상 관심주 ]</span></h2>        <div class='en-code'>        <div>장 전에 움직인 종목을 보면서 당일 주식 시장을 예측하는데 도움을 받을 수 있습니다.</div>        </div>        <br/>            <div id='report_chart'>                 차트상 관심주 내용            </div>        <br/>        <hr />        <br/>        <h2><span style='background-color: #ffff99;' data-en-has-metadata='true'> [ 뉴스 모음 ]</span></h2>        <div class='en-code'>        <div>장 전에 움직인 종목을 보면서 당일 주식 시장을 예측하는데 도움을 받을 수 있습니다.</div>        </div>        <br/>            <div id='report_daliy'>                뉴스 모음 본문            </div>        <br/>        <hr />        </body></html>";
            return basic;
        },
        $getFormatDate : function(strDate) {
            let date = new Date();
            
            if (!this.$fnObjectNull(strDate))
                date = new Date(strDate);

            var year = date.getFullYear();
            var month = (1 + date.getMonth());
            month = month >= 10 ? month : "0" + month;
            var day = date.getDate();
            day = day >= 10 ? day : '0'+day;

            return year + "-" + month + "-" + day;
        }, 
        $getTodayString(_object, _locale) {
            let locale = 'en-US';

            if (!this.$fnObjectNull(_locale))
                locale = _locale;

            if (!this.$fnObjectNull(_object)) {
                if (typeof(_object)  == "string") 
                    return _object;
                return _object.toLocaleDateString(locale);
            }
            const today = new Date();
            return today.toLocaleDateString(locale);
        },
        _leftPad(value) { 
            if (value >= 10) { 
                return value; 
            } 
            return `0${value}`; 
        },
        $toStringByFormatting(source, delimiter = '-') { 
            const year = source.getFullYear(); 
            const month = this._leftPad(source.getMonth() + 1); 
            const day = this._leftPad(source.getDate()); 
            return [year, month, day].join(delimiter); 
        },
        $getTodayWeekDay(_object, _locale) {
            let locale = 'en-US';
            let todayDate = new Date();

            if (!this.$fnObjectNull(_locale))
                locale = _locale;

            if (!this.$fnObjectNull(_object)) {
                if (typeof(_object)  == "string") 
                    return "";

                todayDate = _object;
            }
            return todayDate.toLocaleDateString(locale, {
                weekday: 'long',
              });
        },
        $toastMessage(_bSuccess, _bMessage){
            if (_bSuccess) {
                this.$toast.add({severity: 'info', summary: 'Success', detail: _bMessage, life: 3000});
            }else {
                this.$toast.add({severity: 'fail', summary: 'fail', detail: _bMessage, life: 3000});
            }
        },        
        $log(_logtext) {
            let dev = true;

            if (dev) {
                console.log(_logtext);
            }
        },
        $getParameter(name) {
            name = name.replace(/[\\[]/, "\\[").replace(/[\]]/, "\\]");
            let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.href);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        },
        $onTitleClick(_event, _data) {
            if (_event.ctrlKey == true) {
                this.$router.push({
                    name: "feedData",
                    params : {
                        modify: true,
                        UID : _data.uid,
                    }
                });
            }else {
                window.open(_data.url);
            }
        },
    }
}